import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store/store.js'
import AmazeUI from '@/assets/js/amazeui.min.js'
import imagePreview from '@/assets/js/image-preview-prd.js'
import 'vant/lib/index.css'
import './assets/css/amazeui.min.css'
import './assets/css/master.css'
import './assets/css/main.css'
import './assets/css/product.css'
import './assets/css/news.css'
import './assets/css/service.css'
import './assets/css/about.css'


function redirectToCorrectSite() {
    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    var pcSite = 'http://www.wghglaser.com';
    if (!isMobile) {
        window.location.href = pcSite
    }

}

redirectToCorrectSite()
import AMap from 'vue-amap'
Vue.config.productionTip = false
Vue.use(AMap)
AMap.initAMapApiLoader({
    // 申请的高德key
    key: 'b26b7c08a5230144460c3c164f61d619',
    // 插件集合
    plugin: ['AMap.ToolBar']
});
new Vue({
    router,
    store,
    AmazeUI,
    imagePreview,
    render: h => h(App),
}).$mount('#app')